export default __webpack_public_path__ + "static/media/set_7_Image-6.1491aacc.svg";